import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

import { Document } from 'types/Document';

export const ensureEquityMarketSharePurchaseContractTemplate = async (
  societyId: string
): Promise<Document | undefined> => {
  const { data } = await axiosV2.get('/tradingOffers/contract-template', {
    params: { societyId },
  });
  const decoded = (await decryptResponse(data)) as Document;
  return decoded;
};
